import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetGeoSuggestLoading, EGetGeoSuggestActionTypes } from './types';

export const getSuggestionsLoading: () => TGetGeoSuggestLoading = actionGenerator<EGetGeoSuggestActionTypes.Loading>(
  EGetGeoSuggestActionTypes.Loading,
);
